import React from "react";

function TwitterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M21.429 0H2.57A2.572 2.572 0 000 2.571V21.43A2.572 2.572 0 002.571 24H21.43A2.572 2.572 0 0024 21.429V2.57A2.572 2.572 0 0021.429 0zm-2.62 8.507c.01.15.01.306.01.456 0 4.644-3.535 9.996-9.996 9.996a9.95 9.95 0 01-5.394-1.575c.284.032.557.043.846.043a7.044 7.044 0 004.36-1.5 3.518 3.518 0 01-3.283-2.438c.54.08 1.028.08 1.585-.064a3.514 3.514 0 01-2.812-3.45v-.043a3.511 3.511 0 001.586.445 3.506 3.506 0 01-1.565-2.925c0-.654.172-1.254.477-1.773a9.976 9.976 0 007.243 3.675c-.498-2.384 1.286-4.318 3.429-4.318a3.5 3.5 0 012.566 1.109 6.885 6.885 0 002.228-.847 3.504 3.504 0 01-1.543 1.934 6.992 6.992 0 002.025-.546 7.395 7.395 0 01-1.762 1.821z"></path>
        </g>
      </g>
    </svg>
  );
}

export default TwitterIcon;
